import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SetField } from '../components/Table/fields/SetField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { SelectField } from '../components/Table/fields/SelectField';
import { TimeField } from '../components/Table/fields/TimeField';
import { activityExtra } from './activityExtra';
import { DateField } from '../components/Table/fields/DateField';
import { competitorPriceWithoutActivity } from './competitorPriceWithoutActivity';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { serviceProvider } from './serviceProvider';
import { Services } from '../components/Services/Services';
import { ActivityContact } from '../components/Contacts/ActivityContact';
import { Prices } from '../components/Prices/Prices';
import { Images } from '../components/Images/Images';
import { Venues } from '../components/Venues/Venues';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPLinkField } from '../components/Table/fields/SPLinkField';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { SPImages } from '../components/Images/SPImages';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import DndProviderComponent from '../components/Services/DndProviderComponent';
import { SubActivity } from '../components/Activity/SubActivity';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";

export const activity: SchemaWithClient<any> = {
  name: 'Activity',
  pluralName: 'Activities',
  treeData: true,
  filters: {
    activity_category: {
      name: 'Category',
      schema: enumItems.activityCategory,
    },
    activity_types: {
      name: 'Type',
      schema: enumItems.activityType,
      wait: 'activity_category',
      multiSwitchboard: true,
    },
  },
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Services',
      name: 'services',
      type: 'custom',
      renderer: Services,
      rendererType: 'service',
      columns: ['services', 'guide_hours', 'activity_stripper_roles'],
    },
    {
      id: 3,
      label: 'Contacts',
      name: 'contacts',
      type: 'custom',
      renderer: ActivityContact,
      rendererType: 'contacts',
    },
    {
      id: 3,
      label: 'Prices',
      name: 'prices',
      type: 'custom',
      renderer: Prices,
      rendererType: 'prices',
    },
    {
      id: 4,
      label: 'Images',
      name: 'images',
      type: 'custom',
      renderer: Images,
      rendererType: 'images',
    },
    {
      id: 5,
      label: 'Venues',
      name: 'venues',
      type: 'custom',
      renderer: Venues,
      rendererType: 'venues',
    },
  ],
  sections: [
    {
      id: 1,
      width: 12,
      label: 'General Data',
      name: 'general',
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'name',
              name: 'Name',
              fieldRenderer: SPTextField,
              info: 'ZOÉ-beli neve',
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'sp_name',
              name: 'SP Name',
              fieldRenderer: SPTextField,
              info: 'Sales Partner felé mutatott neve',
              required: true,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              name: 'Activity Category',
              fieldRenderer: SPSelectField.tableAdapter(
                enumItems.activityCategory
              ),
              columnName: 'activity_category',
              info: 'Kategória, csak 1 lehet',
            },
            {
              name: 'Activity Types',
              fieldRenderer: SPSetField.tableAdapter(enumItems.activityType),
              columnName: 'activity_types',
              info: 'Több is lehet hisz van átfedés',
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              name: 'Bus Included',
              fieldRenderer: SPBooleanField,
              columnName: 'bus_included',
            },
            {
              name: 'Active',
              fieldRenderer: SPBooleanField,
              columnName: 'active',
            },
            {
              name: 'Public Website Active',
              fieldRenderer: SPBooleanField,
              columnName: 'public_website_active',
            },
          ],
        },
      ],
    },
    {
      id: 2,
      width: 12,
      label: 'Descriptions',
      name: 'descriptions',
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'description_en',
              name: 'English',
              fieldRenderer: SPRichTextField,
              info:
                'Rövid angol nyelvű, leíró jellegű (nem felsorolásszerű) leírása a programnak amit kérdésre bárkinek el lehet küldeni',
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'description_fr',
              name: 'French',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'description_de',
              name: 'German',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
      ],
    },
    {
      id: 3,
      width: 8,
      label: 'Booking Information',
      name: 'booking_information',
      grids: [
        {
          width: 6,
          columns: [
            {
              columnName: 'booking_informations',
              name: 'Booking Info',
              fieldRenderer: SPRichTextField,
              info:
                'Booking manager számára a foglalással kapcsolatos tudnivalók. Amire figyelni kell ennek a foglalásánál. ',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'service_provider',
              name: 'Service Providers',
              fieldRenderer: SPLinkField,
              columnSchema: serviceProvider,
              info:
                'Azon fő providerek listája akik az adott programot kínálják (kiegészítő provider ide nem kell) ',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'client_infos',
              name: 'Client Info',
              fieldRenderer: SPRichTextField,
              info:
                'Bármi olyan infó, amit az ügyféllel vagy előzetesen a partneren keresztül vagy a helyszínen a Guideon keresztül tudatni kell. Pl. 1. Lövészet előtt nem lehet inni és vinniük kell a személyijüket, különben megtagadjuk a lövészetet refund nélkül. 2 Szállásfoglaláshoz szükség van a személyi okmányokra',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'duty_info',
              name: 'Duty Info',
              fieldRenderer: SPRichTextField,
              info:
                'Hétvégi ügyeletes szempontjából tudni való. Pl. régen péntek estig kellett leadni a bottle servicehez az italválasztást amit az ügyeletes intézett. ',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'availability',
              name: 'Availability',
              fieldRenderer: SPRichTextField,
              info: 'Mikor elérhető a program',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'stripper_infos',
              name: 'Artist Info',
              fieldRenderer: SPRichTextField,
              info:
                'Fellépőt érintő tudnivaló pl. mikorra érkezzen, mit vigyen magával, milyen ruhát, maga helyett küldeni csak előzetes egyeztetés után tud valakit stb. ',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'notes',
              name: 'Notes',
              fieldRenderer: SPRichTextField,
              info: 'Bármi ami a fenti kategóriákban nem foglaltatik benne',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'includes',
              name: 'Includes',
              fieldRenderer: SPRichTextField,
              info:
                'A program tartalma kulcsszavakban a pricelist description füléről',
            },
          ],
        },
      ],
    },
    {
      id: 6,
      width: 4,
      label: 'Duration & Timing',
      name: 'duration_timing',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'duration',
              name: 'Activity net duration',
              fieldRenderer: SPTimeField,
              info:
                'a program tiszta időhossza pl. gokartnál ha 15:00-re mennek és 16:00-kor indulnal vissza a buszhoz, akkor 1 óra',
            },
            {
              columnName: 'city_transfer_duration',
              name: 'Transfer duration',
              fieldRenderer: SPTimeField,
              info: 'start - pickup time',
            },
            {
              columnName: 'full_duration',
              name: 'Full duration',
              fieldRenderer: SPTimeField,
              info: 'activity net duration + 2* transfer duration',
            },
            {
              columnName: 'guide_work_hours',
              name: 'Guide Working Hours',
              fieldRenderer: SPTimeField,
              info:
                'pickup time-tól számítva amíg lerakja a csoportot a program végeztével átlagosan',
            },
            {
              columnName: 'meeting_time_delta',
              name: 'Meeting time delta',
              fieldRenderer: SPTimeField,
              info:
                'pickup time-ot (ami a csoporttal való találkozó és indulás időpontja is egyben) megelőző időhossz, azért, hogy indulásra még a Guide össze tudja szedni a csoportot és pl. buszos program esetén el tudjanak indulni a pickup time időpontjában',
            },
            {
              columnName: 'pickup_time_delta',
              name: 'Pickup time delta',
              fieldRenderer: SPTimeField,
              info:
                'ez a program kezéséig tartó átlagos időhossz ami alatt odaér a Guide a csoporttal',
            },

            {
              columnName: 'latest_activity_start',
              name: 'Latest activity start',
              fieldRenderer: SPTimeField,
              info:
                'legkésőbbi program kezdés (legyen a hétvégi napokra nézve ha változó a nyitvatartás)',
            },
            {
              columnName: 'pickup_place',
              name: 'Pickup Place',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.pickupPlace),
              info: 'Csoporttal a találkozó helyszíne indulásnál',
            },
          ],
        },
      ],
    },
    {
      id: 4,
      width: 12,
      label: 'Contacts',
      name: 'contacts',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'contacts',
              fieldRenderer: ActivityContact,
              info: 'Az activity-hez kapcsolódó Service Providerek kontaktjai.',
            },
          ],
        },
      ],
    },

    {
      id: 7,
      width: 12,
      label: 'Services',
      name: 'services',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'duration',
              fieldRenderer: DndProviderComponent,
              info:
                'Itt kapcsolunk szolgáltatásokat (Service) az Activity-khez. A Service Group-ok csoportosítják a szolgáltatásokat, a BASE Service Group szolgáltatásai mindig lefoglalásra kerülnek, a többi opcionálisan választható foglaláskor.',
            },
          ],
        },
      ],
    },

    {
      id: 9,
      width: 12,
      label: 'Guide Information',
      name: 'services',
      grids: [
        {
          width: 4,
          columns: [
            /* {
              columnName: 'guide_work_hours',
              name: 'Guide Working Hours',
              fieldRenderer: SPTimeField,
            },
            {
              columnName: 'guide_salary',
              name: 'Guide Salary',
              fieldRenderer: SPTextField,
            },*/
            {
              columnName: 'guide_wage',
              name: 'Guide Wage',
              fieldRenderer: SPNumberField,
              info:
                'Guide munkabére függetlenül a valós időtartamtól amit eltöltött (bérek ahhoz vannak átlagosan igazítva)',
            },
            {
              columnName: 'guide_wage_currency',
              name: 'Guide Wage Currency',
              fieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
            },
            {
              columnName: 'guide_bonus',
              name: 'Guide Bonus',
              fieldRenderer: SPNumberField,
              info:
                'Guide Bonus',
            },
            {
              columnName: 'extra_sales_commission',
              name: 'Extra Sales Commission',
              fieldRenderer: SPTextField,
              info: 'ez majd sávos lesz - Guidenak járó jutalék',
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'bad_weather_plan',
              name: 'Bad Weather Plan',
              fieldRenderer: SPRichTextField,
              info:
                'Szabadtéri programoknál a B terv rossz idő esetére amikor is nem megtartható az adott program',
            },
            {
              columnName: 'guide_infos',
              name: 'Guide Info',
              fieldRenderer: SPRichTextField,
              info:
                'Guide számára a fontos tudni valók a program lebonyolításáról. Minden tudnivaló ami kiemelet jelentőséggel bír, amire figyelnie kell, különben gyakran rossz következmények állnak be.  ',
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'flight_delay_plan',
              name: 'Flight Delay Plan',
              fieldRenderer: SPRichTextField,
              info:
                'Ha késik a gép és emiatt lekésik a programot, akkor milyen megoldási lehetőségek vannak ',
            },
            {
              columnName: 'guide_schedule_infos',
              name: 'Guide Schedule Info',
              fieldRenderer: SPRichTextField,
              info:
                'Guide számára az időzítéshez kapcsoló fent nem nevezett tudnivalók. ',
            },
          ],
        },
      ],
    },
    {
      id: 10,
      width: 12,
      label: 'Prices',
      name: 'prices',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'prices',
              fieldRenderer: Prices,
            },
          ],
        },
      ],
    },
    {
      id: 11,
      width: 8,
      label: 'Images',
      name: 'images',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'images',
              fieldRenderer: SPImages,
            },
          ],
        },
      ],
    },
    {
      id: 12,
      width: 4,
      label: 'Venues',
      name: 'venues',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'venues',
              fieldRenderer: Venues,
              info:
                'A Service Providerekhez felvett helyszínek jelennek meg itt. Innen is lehet helyszínt hozzáadni, és Service Providerhez kötni.',
            },
          ],
        },
      ],
    },
    {
      id: 12,
      width: 12,
      label: 'Sub Activities',
      name: 'sub_activities',
      grids: [
        {
          width: 12,
          columns: [
            {
              fieldRenderer: SubActivity,
              columnName: 'sub_activities',
            },
          ],
        },
      ],
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      defaultShow: true,
    },
    sp_name: {
      name: 'SP Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    activity_category: {
      name: 'Activity Category',
      fieldRenderer: SelectField.tableAdapter(enumItems.activityCategory),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.activityCategory
      ),
      url: enumItems.activityCategory.client.getAllPath,
      tempSchema: enumItems.activityCategory,
      switchboard: true,
      defaultShow: true,
    },
    activity_types: {
      name: 'Activity Types',
      fieldRenderer: SetField.tableAdapter(enumItems.activityType),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.activityType),
      url: enumItems.activityType.client.getAllPath,
      tempSchema: enumItems.activityType,
      multiSwitchboard: true,
      defaultShow: true,
    },
    includes: {
      name: 'Includes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    description: {
      name: 'Description',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    booking_informations: {
      name: 'Booking Information',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    availability: {
      name: 'Availability',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    bad_weather_plan: {
      name: 'Bad Weather Plan',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    flight_delay_plan: {
      name: 'Flight Delay Plan',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    city_transfer: {
      name: 'City Transfer',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      defaultShow: false,
    },
    bus_included: {
      name: 'Bus Included',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      defaultShow: true,
    },
    pickup_place: {
      name: 'Pickup Place',
      fieldRenderer: SelectField.tableAdapter(enumItems.pickupPlace),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.pickupPlace),
      url: enumItems.pickupPlace.client.getAllPath,
      tempSchema: enumItems.pickupPlace,
      switchboard: true,
      defaultShow: false,
    },
    description_en: {
      name: 'Description EN',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    description_fr: {
      name: 'Description FR',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    description_de: {
      name: 'Description DE',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    city_transfer_duration: {
      name: 'Transfer Duration',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    city_transfer_distance: {
      name: 'Distance',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      defaultShow: false,
    },
    guide_infos: {
      name: 'Guide Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    guide_schedule_infos: {
      name: 'Guide Schedule Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    guide_wage: {
      name: 'Guide Wage',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    guide_wage_currency: {
      name: 'Guide Wage Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
    },
    guide_bonus: {
      name: 'Guide Bonus',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    client_infos: {
      name: 'Client Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    stripper_infos: {
      name: 'Artist Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    duty_info: {
      name: 'Duty Info',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    duration: {
      name: 'Duration',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    full_duration: {
      name: 'Full Duration',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    meeting_time_delta: {
      name: 'Meeting Time Delta',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    pickup_time_delta: {
      name: 'Pickup Time Delta',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    latest_activity_start: {
      name: 'Latest Activity Start',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    guide_work_hours: {
      name: 'Guide Work Hours',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    extra_sales_commission: {
      name: 'Extra Sales Commission',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      defaultShow: false,
    },
    appointments: {
      name: 'Appointments',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    notes: {
      name: 'Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    active: {
      name: 'Active',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      section: 'general',
      defaultShow: true,
    },
    public_website_active: {
      name: 'Public Website',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      section: 'general',
      defaultShow: true,
    },
    valid_from: {
      name: 'Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      defaultShow: false,
    },
    sub_activities: {
      name: 'Sub Activities',
      fieldRenderer: SetField.tableAdapter(enumItems.activity),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.activity),
      url: enumItems.activity.client.getAllPath,
      tempSchema: enumItems.activity,
      multiSwitchboard: true,
      hideInTableView: true,
    },
    activity_extras: {
      name: 'Activity Extras',
      fieldRenderer: SetField.tableAdapter(activityExtra),
      slidePaneFieldRenderer: SPSetField.tableAdapter(activityExtra),
      url: activityExtra.client.getAllPath,
      tempSchema: activityExtra,
      multiSwitchboard: true,
      defaultShow: false,
      hideInTableView: true,
    },
    competitor_prices: {
      name: 'Competitor Prices',
      fieldRenderer: SetField.tableAdapter(competitorPriceWithoutActivity),
      slidePaneFieldRenderer: SPSetField.tableAdapter(
        competitorPriceWithoutActivity
      ),
      url: competitorPriceWithoutActivity.client.getAllPath,
      tempSchema: competitorPriceWithoutActivity,
      multiSwitchboard: true,
      defaultShow: false,
      hideInTableView: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  viewTable: 'activities',
  client: new Client('/activities'),
};
